export default {
  path: '/nozzle_outs',
  name: 'nozzle_outs',
  component: () => import('../components/nozzleout/Layout'),
  redirect: { name: 'NozzleOutList' },
  meta: {
    breadcrumb: 'profile.nozzle.nozzlesout',
  },
  children: [
    {
      name: 'NozzleOutList',
      path: '',
      component: () => import('../views/nozzleout/List'),
      meta: {
        breadcrumb: 'global.list',
      },
    },
    {
      name: 'NozzleOutCreate',
      path: 'new',
      component: () => import('../views/nozzleout/Create'),
      meta: {
        breadcrumb: 'global.add',
      },
    },
    {
      name: 'NozzleOutUpdate',
      path: ':id/edit',
      component: () => import('../views/nozzleout/Update'),
      meta: {
        breadcrumb: 'profile.nozzle.nozzleout',
      },
    },
    {
      name: 'NozzleOutShow',
      path: ':id',
      component: () => import('../views/nozzleout/Show'),
      meta: {
        breadcrumb: 'profile.nozzle.nozzleout',
      },
    }
  ]
};
